import React from 'react';
import PortfolioBlock from './PortfolioBlock';
import { Box, Grid } from '@mui/material';
import { info } from '../../assets/info/Info';

export default function Portfolio({ darkMode }) {
  return (
    <Box mt={'3rem'}>
      <h2 style={{ textAlign: 'center' }}>Professional Projects</h2>
      <div className='gridContainer'>
        <Grid container spacing={3} style={{ padding: '20px' }}>
          {info.portfolio.map((project, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <PortfolioBlock {...project} darkMode={darkMode} />
            </Grid>
          ))}
        </Grid>
      </div>
    </Box>
  );
}
